import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import * as deliveryAction from '../../../../../actions/deliveryAction';
import ListItemOrder from './ListItemOrder';
import { translate } from '../../../../../utils/util';
import PaginationScrollNew from '../../../../../components/UI/ListPaginationUlNew';
import { ENUMS, VISIONS } from '../../../../../utils/constants';
import { getVision } from '../../../../../services/auth';
import DeliveryService from '../../../../../services/DeliveryService';
import { Collapsible, Input, Button } from '../../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../../utils/handleChangeHooks';

const PickingDeliveryListOrder = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [orders, setOrders] = useState([]);
    const [refreshed, setRefreshed] = useState(0);
    const [filter, setFilter] = useState({});

    const refreshComponent = () => {
        setRefreshed(refreshed + 1);
    };

    useEffect(() => {
        if (props.data?.items?.length > 0) {
            if (orders.length > 0 && currentPage === 0) {
                setOrders(props.data.items);
            } else {
                setOrders((prevState) => ([...prevState, ...props.data.items]));
            }
        } else {
            setOrders([]);
        }
        // eslint-disable-next-line
    }, [props?.data?.items]);

    useEffect(() => {
        if (orders.length > 0 || currentPage > 0) {
            setCurrentPage(0);
        }
        // eslint-disable-next-line
    }, [props.allOrders]);

    useEffect(() => {
        var dataFilter = {
            ...props.filter,
            allOrders: props.allOrders,
            almox: props.almox,
            mapping: getVision() === VISIONS.Fiasa,
            ...filter
        };

        props.getOrders(dataFilter, {
            PageSize: 25,
            PageIndex: currentPage
        });
        // eslint-disable-next-line
    }, [currentPage, refreshed, props.allOrders]);

    const onSelectChange = (event, item) => {
        event.preventDefault();
        if (item.status !== ENUMS.eOrderStatus.WaitingFinish.value) {
            if (item.inicialQrCode) {
                return props.history.replace({
                    pathname: `../delivery/startDelivery`,
                    state: { dolly: event.inicialQrCode }
                });
            }
            props.setOrder(item);
            props.history.push({
                pathname: `../delivery/startDelivery/order/missions/${item.items[0].orderItemId}`
            });
        }
    };

    const onFilterKanban = (alert) => {
        if (alert === filter.typeAlert) {
            filter.typeAlert = null
        } else {
            filter.typeAlert = alert;
        }
        setFilter({ ...filter });
        refreshComponent();
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    return (
        <div id="listLPorders" className="container-fluid">
            {
                (getVision() === VISIONS.Fiasa || getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) && (
                    <>
                        <div style={{ marginLeft: '15px' }}>
                            <span>{translate('line-picking:linepicking.total-count')} {props.data.totalCount}</span>
                            <>
                                <span
                                ><i className={`mdi mdi-24px ${filter.typeAlert === ENUMS.eTypeAlert.Blue.value ? 'mdi-36px' : 'mdi-24px'} mdi-circle`}
                                    onClick={() => onFilterKanban(ENUMS.eTypeAlert.Blue.value)}
                                    style={{ color: ENUMS.eTypeAlert.Blue.color, paddingLeft: '10px' }} />
                                </span>
                                <span
                                ><i className={`mdi mdi-24px ${filter.typeAlert === ENUMS.eTypeAlert.Yellow.value ? 'mdi-36px' : 'mdi-24px'} mdi-circle`}
                                    onClick={() => onFilterKanban(ENUMS.eTypeAlert.Yellow.value)}
                                    style={{ color: ENUMS.eTypeAlert.Yellow.color, paddingLeft: '10px' }} />
                                </span>
                                <span
                                ><i className={`mdi mdi-24px ${filter.typeAlert === ENUMS.eTypeAlert.Red.value ? 'mdi-36px' : 'mdi-24px'} mdi-circle`}
                                    onClick={() => onFilterKanban(ENUMS.eTypeAlert.Red.value)}
                                    style={{ color: ENUMS.eTypeAlert.Red.color, paddingLeft: '10px' }} />
                                </span>
                            </>
                        </div>
                    </>)
            }
            <div className="container" style={{ marginTop: '0px' }}>
                <Collapsible
                    id="linePicking"
                    close="true"
                    header={`Filtros`}
                    body={
                        <>
                            <div id="formsReport" className="row">
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="routePdu"
                                        name='routePdu'
                                        label="Rota Pdu"
                                        type="text"
                                        onChange={onChange}
                                    />
                                </div>

                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="line"
                                        name='line'
                                        label="Linha"
                                        type="text"
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="parts"
                                        name='parts'
                                        label="Trecho"
                                        type="text"
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="street"
                                        name='street'
                                        label="Rua"
                                        type="text"
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="station"
                                        name='station'
                                        label="Estação"
                                        type="text"
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="gravitational"
                                        name='gravitational'
                                        label="Gravitacional"
                                        type="text"
                                        onChange={onChange}
                                    />
                                </div>

                            </div>
                            <div className="row" style={{ paddingTop: '5px' }}>
                                <Button onClick={() => setRefreshed(refreshed + 1)} full="true" text={translate('delivery:general.search')} />
                            </div>
                        </>
                    }
                />
            </div>
            <PaginationScrollNew
                page={props.data?.totalPages}
                current={{ currentPage, setCurrentPage }}
                data={
                    orders.map((item) => {
                        return (
                            <ListItemOrder
                                key={`o-${item.orderId}-${item.status}`}
                                route={`./order/${item.orderCode}/missions`}
                                data={item}
                                kanban={props.location?.state?.kanban}
                                onSelectChange={(event) => onSelectChange(event, item)}
                            />
                        );
                    })
                }
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        filter: state.deliveryReducer.filter,
        orders: state.deliveryReducer.orders,
        user: state.userReducer.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOrder: (order) => {
            dispatch(deliveryAction.setOrder(order));
        },
        getOrders: (filter, pagination, callback) => {
            dispatch(DeliveryService.getOrders(filter, pagination, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingDeliveryListOrder)));
